import InfiniteScroll from 'react-infinite-scroll-component';
import { Role } from 'auth';
import { Fragment, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRegisterPermissionsQuery } from '@/modules/common/queries/permissions.ts';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { HolderEditItem } from '@/modules/issuer-dashboard/components/holder-create/HolderEditItem.tsx';
import { useIssuerGetInvestorsEditListQuery } from '@/modules/issuer-dashboard/queries/holder-create.tsx';
import { issuerDashboardPaths } from '@/modules/issuer-dashboard/routes.tsx';
import { EmptyListState, Spinner } from 'ui';

const EditRequestsTab = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const { data: dataRegisterPermissions, isLoading: isLoadingRegisterPermissions } =
    useRegisterPermissionsQuery();
  const {
    data: dataInvestorsEditList,
    isLoading,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useIssuerGetInvestorsEditListQuery({
    page: 1,
    page_size: 16,
  });

  useEffect(() => {
    if (!dataRegisterPermissions?.holder_details_permission && !isLoadingRegisterPermissions) {
      navigate(
        {
          pathname: issuerDashboardPaths.static.holders,
          search: params.toString(),
        },
        {
          replace: false,
        },
      );
    }
  }, [dataRegisterPermissions?.holder_details_permission, isLoadingRegisterPermissions]);

  return (
    <div className="w-full flex flex-col items-start gap-4">
      <EmptyListState
        title={'No holder requests yet'}
        description={'You can create a holder using the button above'}
        isLoading={isLoading}
        itemsCount={dataInvestorsEditList?.pages?.[0]?.total ?? 0}
      />
      {(isLoading || (isFetching && !isFetchingNextPage)) && (
        <div className="w-full h-full min-h-[300px] flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      )}
      {(!isFetching || isFetchingNextPage) && !!dataInvestorsEditList?.pages?.[0]?.total && (
        <InfiniteScroll
          next={fetchNextPage}
          dataLength={dataInvestorsEditList?.pages.length ?? 0}
          hasMore={hasNextPage || false}
          style={{ overflow: 'unset' }}
          loader={
            <div className="flex justify-center items-center h-16 w-full">
              <Spinner size="md" variant="primary" />
            </div>
          }
          scrollableTarget="scrollable"
        >
          <div className="w-full flex flex-col gap-2">
            {dataInvestorsEditList?.pages?.map(({ data }, i) => (
              <Fragment key={i}>
                {data.map(item => (
                  <HolderEditItem key={item.id} item={item} />
                ))}
              </Fragment>
            ))}
          </div>
        </InfiniteScroll>
      )}
    </div>
  );
};

export default withPrivateAccess(EditRequestsTab, [Role.SR_ISSUER, Role.SR_ISSUER_ADMIN]);
